<form class="border border-dark bg-white rounded mt-3 mb-2"
  [ngClass]="this.partnerType=='SYSTEM'? 'row g-4 mt-3' : 'row g-3 mt-3'" (ngSubmit)="onGetTransaction()"
  [formGroup]="searchForm">

  <div class="form-floating col mb-2">
    <input type="date" class="form-control" placeholder="Date de d&#233;part" id="startDate"
      formControlName="startDate">
    <label for="startDate" class="form-label">Date de d&#233;part</label>
  </div>
  <div class="form-floating  col mb-2">

    <input type="date" class="form-control" id="endDate" placeholder="Date de fin" formControlName="endDate"
      name="endDate">
    <label for="endDate" class="form-label">Date de fin</label>
  </div>
  @if (this.partner?.canBeParent) {
    <div class="form-floating col mb-2">
      <select class="form-select" id="partner" formControlName="partner" name="partner">
        <option>{{partnerLabel}}</option>
        
        @for (merch of merchants; track merch) {
          <option value="{{merch.id}}">{{merch.name}}</option>
        }
      </select>
      <label for="partner" class="form-label">{{partnerLabel}}</label>
    </div>
  }@else {
    <input type="hidden" class="form-control mr-4" id="partner"
      formControlName="partner" name="partner" value="{{this.idPartner}}">
  }
  <div class="col mb-2">
    <button type="submit" class="mt-3 w-100 btn btn-success">Valider</button>
  </div>

</form>


<div class="modal" tabindex="-1" role="dialog" id="modalResult" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body"><span class="{{this.messageColor}} text-center font-weight-bold">{{this.message}}</span>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
    </div>
  </div>
</div>
</div>

<div class="row mt-2  ms-2">

  <div class="col  mt-2 justify-content-start">

    <button class="btn border border-dark  me-2" (click)="exportToExcel()">
      <i class="fa fa-file-excel-o btn me-2" style="color: green;" aria-hidden="false">Excel</i>
    </button>
    <button class="btn border border-dark me-2 " (click)="exportToPdf()">
      <i class="fa fa-file-pdf-o btn mr-2" style="color: red;" aria-hidden="false">Pdf</i>
    </button>
    @if (mcc=='8299') {
      <button class="btn border border-dark " (click)="exportSchema()">
        <i class="fa fa-file-text-o btn mr-2" style="color: green;" aria-hidden="false">Schema
        comptable</i>
      </button>
    }
  </div>
  <div class="col  input-group mt-2 justify-content-end">
    <div class="input-group-text">
      <i class="fa fa-search " aria-hidden="true"></i>
      <input type="search" class="form-control" [formControl]="searchTrx" placeholder="Rechercher"
        (keyup)="onSearchTrx($event)" />
    </div>
  </div>
</div>
<div id="listTransaction" class="row">
  <div [ngClass]="partner?.type!='MERCHANT'?'g-6 ':'g-5 '" class="row mt-0">
    <table class="table table-bordered table-hover table-striped ms-2 me-2" id="tableTrx">
      <thead class="table-success">
        <tr>
          <th class="col">Date</th>
          <th class="col">Montant</th>
          <th class="col">Réference</th>
          @if (partner?.type!='MERCHANT') {
            <th class="col">Etablissement</th>
          }
          <th class="col">status</th>
          <th class="col">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (trx of filteredTransactions | paginate : pageConfig; track trx) {
          <tr>
            @if(trx.status=='PAID'){
              <td>{{trx.paymentDate}}</td>
            }
            @else{
            <td>{{trx.modifiedAt}}</td>
          }
          <td>{{trx.amount}}</td>
          <td>{{trx.requestId}}</td>
          @if (partner?.type!='MERCHANT') {
            <td>{{trx.partner?.name}}</td>
          }
          @if (trx.status=='FAILED') {
            <td class="bg-danger round text-white">&Eacute;CHOU&Eacute;</td>
          }
          @if (trx.status=='PENDING') {
            <td class="bg-warning round text-white">EN ATTENTE</td>
          }
          @if (trx.status=='VALIDATED') {
            <td class="bg-success round text-white">SUCC&Eacute;S</td>
          }
          @if (trx.status=='PAID') {
            <td class="bg-success round text-white">SUCC&Eacute;S</td>
          }
          @if (trx.status=='CANCELED') {
            <td class="bg-secondary round text-white">ANNUL&Eacute;</td>
          }
          <td><button type="button" class="btn btn-success" (click)="onDetailsTrx(trx)"
          data-bs-target="detailsTrx">Details</button></td>
        </tr>
      }
    </tbody>

  </table>
  <div class="d-flex justify-content-center">
    <pagination-controls previousLabel="Precedent" nextLabel="Suivant" (pageChange)="onNextPage($event)">
    </pagination-controls>
  </div>
</div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="detailsTrx">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-success round">
        <h3 class="d-flex align-items-center text-white">D&#233;tails transaction</h3>
      </div>
      <div class="modal-body">
        <div><span class="fs-3">Date transaction : </span><span class="fs-2 fw-bold">{{currentTrx.createAt}}</span>
      </div>
      <div><span class="fs-3">Montant: </span><span class="fs-2 fw-bold">{{currentTrx.amount}}
    {{currentTrx.currency?.currencyCode}}</span></div>
    <div><span class="fs-3">Moyen de paiment : </span><span
  class="fs-2 fw-bold">{{currentTrx.paymentNetwork}}</span></div>
  <div><span class="fs-3">Reference : </span><span class="fs-2 fw-bold">{{currentTrx.reference}}</span></div>

</div>
</div>
</div>
</div>